import { isEqual } from 'lodash-es';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { MIXPANEL_PRODUCT } from 'lib/analytics/constants';
import {
  generateTalkTopicsList,
  getTalkPageContext
} from 'lib/analytics/mixpanel-helpers';
import { sourceContext } from 'lib/business';

import { useTalkPageContext } from 'components/pages/dubbing/slug/talk-page-context';

import { MixpanelVideoDetails } from '../../analytics';
import useVideoPlayerStore from '../../store';

export const useMixpanelData = video => {
  const router = useRouter();
  const { playlistSlug, language } = useTalkPageContext();

  const { mixpanelTalkDetails, setMixpanelTalkDetails, transcriptLanguage } =
    useVideoPlayerStore(state => ({
      mixpanelTalkDetails: state.mixpanelTalkDetails,
      setMixpanelTalkDetails: state.setMixpanelTalkDetails,
      transcriptLanguage: state.transcriptLanguage
    }));

  useEffect(() => {
    const routerPath = router.asPath.replace(/\?.*$/, '');
    const videoDataForMixpanel: MixpanelVideoDetails = {
      talk_id: video.id,
      talk_slug: video.slug,
      video_duration: video.duration,
      video_topics: generateTalkTopicsList(video.topics),
      video_post_date: video.publishedAt,
      talkstar_context: video.videoContext,
      talk_language: video.audioInternalLanguageCode,
      talk_page_view_context: getTalkPageContext(routerPath),
      system_language: navigator?.language || null,
      product: MIXPANEL_PRODUCT,
      recommendation_id: router?.query?.rid || null,
      talk_type: video.type.name,
      playlist_slug: playlistSlug,
      // using router over talk page context language as it will default to en
      language_parameter_value: router.query?.language || null,
      transcript_language: transcriptLanguage || language,
      media_type: video?.__typename || null,
      content_discovery_context: sourceContext()
    };

    if (!isEqual(mixpanelTalkDetails, videoDataForMixpanel)) {
      setMixpanelTalkDetails(videoDataForMixpanel);
    }
  }, [
    video,
    router,
    mixpanelTalkDetails,
    setMixpanelTalkDetails,
    transcriptLanguage,
    language,
    playlistSlug
  ]);
};
